import React from 'react'

function PageNotFound() {
  return (
    <div style={{textAlign : "center", fontFamily : "sans-serif", marginTop : "150px"}} >
        <h2>Sorry, this page isn't available.</h2>
        <p style={{ marginTop : "20px"}} >The link you followed may be broken, or the page may have been removed. Go back to Instagram.</p>
    </div>
  )
}

export default PageNotFound